module.exports = __webpack_public_path__ + "static/media/IDP_process.7229e37d.jpg";